// src/components/ui/EmptyState.js
import React from 'react';
import Btn from './Btn';

const EmptyState = ({ icon: I, title, desc, ctaLabel, onCtaClick }) => (
  <div className="text-center py-10 sm:py-16">
    <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-rose-100 to-fuchsia-100 dark:from-rose-900/30 dark:to-fuchsia-900/30 flex items-center justify-center mx-auto mb-4">
      <I size={24} className="text-rose-500 dark:text-rose-400 sm:hidden" />
      <I size={28} className="text-rose-500 dark:text-rose-400 hidden sm:block" />
    </div>
    <h3 className="text-base sm:text-lg font-medium mb-1.5 dark:text-gray-100">{title}</h3>
    <p className="text-sm text-gray-400 dark:text-gray-400 mb-5 max-w-sm mx-auto">{desc}</p>
    {ctaLabel && onCtaClick && (
      <div className="flex justify-center">
        <Btn v="outline" size="sm" onClick={onCtaClick}>
          {ctaLabel}
        </Btn>
      </div>
    )}
  </div>
);

export default EmptyState;
